import { render, staticRenderFns } from "./HeaderCellDefault.vue?vue&type=template&id=bb0abbc4&scoped=true&"
import script from "./HeaderCellDefault.vue?vue&type=script&lang=js&"
export * from "./HeaderCellDefault.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCellDefault.vue?vue&type=style&index=0&id=bb0abbc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0abbc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
